import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import Loader from "../../../components/loader/Loader";
import { deletePost, getPost } from "../../../feature/posts/postSlice";
import "./allBlog.scss";

const AllBlog = () => {
  const dispatch = useDispatch();
  const { isLoding, posts } = useSelector((state) => state.posts);

  useEffect(() => {
    dispatch(getPost());
  }, [dispatch]);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete && id) {
        dispatch(deletePost(id));
        new Promise((resolve) => resolve(dispatch(getPost())));
        swal("Blog delete successfully", {
          icon: "success",
        });
      }
    });
    setTimeout(() => {
      window.location.reload(false);
    }, 3000);
  };

  return (
    <div className="all-blog-container">
      {isLoding ? (
        <Loader />
      ) : (
        <div className="my-tbl" style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Post Title</th>
                <th>Create Time</th>
                <th>Image Show</th>
                <th>Actions</th>
              </tr>
            </thead>
            {posts.AllPosts &&
              posts.AllPosts.map((blog, index) => {
                return (
                  <tbody key={blog._id}>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{blog.title}</td>
                      <td>{new Date(blog.createdOn).toLocaleDateString()}</td>
                      <td>
                        <img src={`${blog.image}`} alt="blog-img" />
                      </td>
                      <td className="action-btn">
                        <Link to="/dashboard/edit_post" state={blog}>
                          <Button className="edit-btn blog-action">Edit</Button>
                        </Link>

                        <Button
                          className="delete-btn blog-action"
                          onClick={() => handleDelete(blog._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                );
              })}
          </table>
        </div>
      )}
    </div>
  );
};

export default AllBlog;
